<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.fb_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
        <div class="weui-form-preview__item" slot="fb_pjcode">
            <label class="weui-form-preview__label">{{
              customLabel.fb_pjcode || "项目单号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fb_pjcode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pj_dename">
            <label class="weui-form-preview__label">{{
              customLabel.pj_dename || "项目名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pj_dename
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fb_pjemname">
            <label class="weui-form-preview__label">{{
              customLabel.fb_pjemname || "项目负责人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fb_pjemname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pj_emtel">
            <label class="weui-form-preview__label">{{
              customLabel.pj_emtel || "联系电话"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pj_emtel
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fb_ppname">
            <label class="weui-form-preview__label">{{
              customLabel.fb_ppname || "阶段名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fb_ppname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pp_emname">
            <label class="weui-form-preview__label">{{
              customLabel.pp_emname || "阶段负责人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pp_emname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pj_end_date">
            <label class="weui-form-preview__label">{{
              customLabel.pj_end_date || "项目计划完成日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.pj_end_date
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.pb_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="pb_task">
              <label class="weui-form-preview__label">{{
                customLabel.pb_task || "问题点"
              }}</label>
              <span class="weui-form-preview__value">{{ item.pb_task }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pb_planenddate">
              <label class="weui-form-preview__label">{{
                customLabel.pb_planenddate || "要求完成日期"
              }}</label>
              <span class="weui-form-preview__value"  v-format="'yyyy-MM-dd'">{{ item.pb_planenddate }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pt_emname">
              <label class="weui-form-preview__label">{{
                customLabel.pt_emname || "任务处理人"
              }}</label>
              <span class="weui-form-preview__value">{{ item.pt_emname }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pt_code">
              <label class="weui-form-preview__label">{{
                customLabel.pt_code || "任务单号"
              }}</label>
              <span class="weui-form-preview__value">{{ item.pt_code }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pt_taskstatus">
              <label class="weui-form-preview__label">{{
                customLabel.pt_taskstatus || "任务状态"
              }}</label>
              <span class="weui-form-preview__value">{{ item.pt_taskstatus }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pt_result">
              <label class="weui-form-preview__label">{{
                customLabel.pt_result || "处理结果"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pt_result
              }}</span>
            </div>
          </custom-layout>
        </div>
      </div>

      <file-list v-model="form.main.pt_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/plm/demand_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
  },
  data() {
    return {
      baseUrl: "/api/plm/problemfeedback",
      codeField: "fb_code",
      statusField: "fb_statuscode",
      caller: "PlmProblemFeedback",
      xtype: "plm-problemfeedback-formpanel",
    };
  },
};
</script>